export default {
  online_payments_off:
    'Lieferung ist eingeschaltet, kann aber nicht bestellt werden: Lieferungen per Kurier werden nur online bezahlt, und Online-Zahlungen sind ausgeschaltet.',
  gateway_not_verified:
    'Lieferung ist eingeschaltet, kann aber nicht bestellt werden: Lieferungen per Kurier werden nur online bezahlt, und Online-Zahlungen sind bis zur Verifizierung Ihres Zahlungskontos pausiert.',
  stripe_processing_fee_missing:
    'Lieferung ist eingeschaltet, kann aber nicht bestellt werden: Lieferungen per Kurier werden nur online bezahlt, und Online-Zahlungen sind pausiert, bis Ihr Partner seine Verarbeitungsgebühr festlegt.',
  turn_on_online_payments: 'Online-Zahlungen einschalten',
};
